<div class="history-container mat-elevation-z2">
  <div class="history-header">
    <div class="header-title">
      <h2>
        <span class="title-icon">
          <i class="far fa-history"></i>
        </span>
        Item History
      </h2>
      <div class="item-info">
        <span class="item-id">{{changes[0]?.itemIdentifier}}</span>
        <span class="item-desc">{{changes[0]?.itemDescription}}</span>
      </div>
    </div>
    <div class="header-actions">
      <button mat-raised-button color="primary" class="btn-sm" (click)="generateAuditReport()">
        <i class="far fa-file-export"></i>&nbsp;
        <span>Export Report</span>
      </button>
    </div>
  </div>

  <div class="history-timeline">
    <mat-accordion>
      <mat-expansion-panel *ngFor="let change of changes; let i = index" 
                         [expanded]="i === 0"
                         class="history-panel"
                         [ngClass]="getChangeTypeClass(change.changeType)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="change-header">
              <div class="change-version">
                <span class="version-number">{{change.version}}</span>
              </div>
              <div class="change-info">
                <div class="change-type">{{change.changeType}}</div>
                <div class="change-meta">
                  <span class="change-date">{{formatDate(change.changeDate)}}</span>
                  <span class="change-user">by {{change.changedBy}}</span>
                </div>
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="change-content">
          <div class="changes-table-wrapper">
            <table mat-table [dataSource]="change.changes" class="changes-table">
              <ng-container matColumnDef="field">
                <th mat-header-cell *matHeaderCellDef>Field</th>
                <td mat-cell *matCellDef="let item">
                  <div class="cell-content">{{item.field}}</div>
                </td>
              </ng-container>

              <ng-container matColumnDef="oldValue">
                <th mat-header-cell *matHeaderCellDef>Previous Value</th>
                <td mat-cell *matCellDef="let item" class="old-value">
                  <div class="cell-content">
                    <i class="far fa-minus-circle"></i>
                    <span class="value-text" [title]="item.oldValue || '-'">{{item.oldValue || '-'}}</span>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="newValue">
                <th mat-header-cell *matHeaderCellDef>New Value</th>
                <td mat-cell *matCellDef="let item" class="new-value">
                  <div class="cell-content">
                    <i class="far fa-plus-circle"></i>
                    <span class="value-text" [title]="item.newValue || '-'">{{item.newValue || '-'}}</span>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div> 